/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import LoadingIcon from 'bundles/courseraLoadingIcon/LoadingIcon';

const Loading = () => (
  <div
    css={css`
      min-height: 60vh;
    `}
  >
    <LoadingIcon />
  </div>
);

export default Loading;
